(function(){
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, {rootMargin:'0px 0px -8% 0px', threshold:0.08}) : null;
  function $$(r,s){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); }
  function initReveal(root){ $$(root,'.ge-reveal:not(.is-in)').forEach(function(el){ io ? io.observe(el) : el.classList.add('is-in'); }); }
  function initPicker(root){
    $$(root,'[data-ge-picker]').forEach(function(p){
      if(p.dataset.ready) return; p.dataset.ready='1';
      var opts=$$(p,'[data-ge-opt]'), recs=$$(p,'[data-ge-rec]');
      opts.forEach(function(o){ o.addEventListener('click', function(){
        opts.forEach(function(x){ x.setAttribute('aria-pressed', x===o ? 'true':'false'); });
        recs.forEach(function(r){ r.hidden = r.dataset.geRec !== o.dataset.geOpt; });
      }); });
    });
  }
  function fmtDate(v){ if(!v) return ''; var d=new Date(v+'T12:00:00'); if(isNaN(d)) return v; return d.toLocaleDateString('en-GB',{weekday:'short',day:'numeric',month:'short',year:'numeric'}); }
  function stepValue(step){
    var kind=step.dataset.kind;
    if(kind==='choice'){ var c=step.querySelector('input:checked'); return c?c.value:''; }
    if(kind==='multi'){ return $$(step,'input:checked').map(function(x){return x.value;}).join(', '); }
    var f=step.querySelector('input,textarea'); if(!f) return '';
    return kind==='date' ? fmtDate(f.value) : f.value.trim();
  }
  function opener(src){
    var s=(src||'').toLowerCase();
    if(s.indexOf('wholesale')>-1) return "Hi Grafton Ecom UAE 👋 I'd like to apply for a wholesale trade account.";
    if(s.indexOf('call')>-1 || s.indexOf('booking')>-1) return "Hi Grafton Ecom UAE 👋 I'd like to book a free video call.";
    if(s.indexOf('fulfil')>-1) return "Hi Grafton Ecom UAE 👋 I'd like a quote for your fulfilment service.";
    if(s.indexOf('plan')>-1 || s.indexOf('start')>-1) return "Hi Grafton Ecom UAE 👋 I'd like a free plan for my online business.";
    return "Hi Grafton Ecom UAE 👋 I'm interested in your services and would like some help.";
  }
  function initQuiz(root){
    var today=new Date(); var iso=new Date(today.getTime()-today.getTimezoneOffset()*60000).toISOString().slice(0,10);
    $$(root,'[data-ge-date]').forEach(function(d){ d.min=iso; });
    $$(root,'[data-ge-quiz]').forEach(function(form){
      if(form.dataset.ready) return; form.dataset.ready='1';
      var steps=$$(form,'[data-step]'), i=0;
      var count=form.querySelector('[data-ge-count]'), bar=form.querySelector('[data-ge-bar]'), err=form.querySelector('[data-ge-err]');
      var back=form.querySelector('[data-ge-back]'), next=form.querySelector('[data-ge-next]'), submit=form.querySelector('[data-ge-submit]');
      function show(n){
        i=n; steps.forEach(function(s,k){ s.hidden = k!==i; });
        var fin = steps[i].hasAttribute('data-final');
        count.textContent='Step '+(i+1)+' of '+steps.length;
        bar.style.width=((i+1)/steps.length*100)+'%';
        back.disabled = i===0; next.hidden = fin; submit.hidden = !fin; err.textContent='';
      }
      function valid(step){
        $$(step,'.is-err').forEach(function(x){x.classList.remove('is-err');});
        if(step.hasAttribute('data-final')){
          var ok=true;
          $$(step,'[data-req]').forEach(function(f){ if(!f.value.trim()){ f.classList.add('is-err'); ok=false; } });
          var ph=step.querySelector('[name=phone]');
          if(ph && ph.value && ph.value.replace(/[^0-9]/g,'').length<7){ ph.classList.add('is-err'); ok=false; }
          var em=step.querySelector('[name=email]');
          if(em && em.value && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em.value)){ em.classList.add('is-err'); ok=false; }
          if(!ok) err.textContent='Please fill in the highlighted fields.';
          return ok;
        }
        if(step.dataset.required==='true' && !stepValue(step)){ err.textContent = step.dataset.kind==='date' ? 'Please pick a date to continue.' : 'Please choose or type an answer to continue.'; return false; }
        return true;
      }
      function go(){ if(valid(steps[i]) && i<steps.length-1) show(i+1); }
      next.addEventListener('click', go);
      back.addEventListener('click', function(){ if(i>0) show(i-1); });
      steps.forEach(function(s){
        if(s.dataset.kind==='choice'){ $$(s,'input').forEach(function(r){ r.addEventListener('change', function(){ setTimeout(go, 280); }); }); }
        $$(s,'input[type=text],input[type=tel],input[type=email],input[type=date]').forEach(function(t){ t.addEventListener('keydown', function(e){ if(e.key==='Enter'){ e.preventDefault(); if(!s.hasAttribute('data-final')) go(); } }); });
      });
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var fin=steps[steps.length-1]; if(!valid(fin)) return;
        var g=function(n){ var f=fin.querySelector('[name='+n+']'); return f?f.value.trim():''; };
        var src=form.dataset.source||'Website';
        var lines=[form.dataset.opener || opener(src),''];
        var ans=[];
        steps.forEach(function(s){ if(s.hasAttribute('data-final')) return; var v=stepValue(s); if(v) ans.push('• '+s.dataset.label+': '+v); });
        if(ans.length){ lines.push('A bit about me:'); lines=lines.concat(ans); lines.push(''); }
        lines.push('My details:');
        if(g('name')) lines.push('Name: '+g('name'));
        if(g('business')) lines.push('Business: '+g('business'));
        if(g('phone')) lines.push('WhatsApp: '+g('phone'));
        if(g('email')) lines.push('Email: '+g('email'));
        if(g('city')) lines.push('City: '+g('city'));
        if(g('notes')) { lines.push(''); lines.push(g('notes')); }
        lines.push('','Thank you!','','(Sent from graftonecom.ae – '+src+')');
        var url='https://wa.me/'+form.dataset.wa+'?text='+encodeURIComponent(lines.join('\n'));
        var link=form.querySelector('[data-ge-walink]'); if(link) link.href=url;
        steps.forEach(function(s){ s.hidden=true; });
        form.querySelector('[data-ge-nav]').hidden=true; form.querySelector('.ge-quiz__top').hidden=true; err.textContent='';
        form.querySelector('[data-ge-done]').hidden=false;
        var w=window.open(url,'_blank'); if(!w){ location.href=url; }
      });
      show(0);
    });
  }
  function modal(){ return document.querySelector('[data-ge-modal]'); }
  function openModal(){ var m=modal(); if(!m) return false; m.hidden=false; document.documentElement.classList.add('ge-lock'); var f=m.querySelector('input,button.ge-modal__x'); if(f) setTimeout(function(){ f.focus({preventScroll:true}); },50); return true; }
  function closeModal(){ var m=modal(); if(!m) return; m.hidden=true; document.documentElement.classList.remove('ge-lock'); }
  function headerH(){ var h=document.querySelector('.section-header'); return h ? h.getBoundingClientRect().height : 0; }
  function scrollToId(id){ var t=document.getElementById(id); if(!t) return false; var y=t.getBoundingClientRect().top+window.scrollY-headerH()-16; window.scrollTo({top:Math.max(0,y),behavior:'smooth'}); return true; }
  document.addEventListener('click', function(e){
    var a=e.target.closest && e.target.closest('a');
    if(a){
      var h=a.getAttribute('href')||'';
      if((h==='#book' || /calendly\.com/i.test(h)) && openModal()){ e.preventDefault(); return; }
      var m=h.match(/^(?:([^#]*))#([\w-]+)$/);
      if(m && m[2]!=='book' && (!m[1] || m[1]===location.pathname) && document.getElementById(m[2])){ e.preventDefault(); scrollToId(m[2]); history.replaceState(null,'','#'+m[2]); }
    }
    if(e.target.closest && e.target.closest('[data-ge-close]')) closeModal();
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeModal(); });
  function initHeader(){
    var icons=document.querySelector('.header__icons');
    if(icons && !document.querySelector('.ge-hcta') && modal()){
      var a=document.createElement('a'); a.href='#book'; a.className='ge-hcta'; a.innerHTML='<i></i>Book a free call'; icons.appendChild(a);
    }
    var on=function(){ document.documentElement.classList.toggle('ge-scrolled', window.scrollY>20); };
    on(); window.addEventListener('scroll', on, {passive:true});
    if(location.hash==='#book') openModal();
    else if(location.hash.length>1){ var id=location.hash.slice(1); setTimeout(function(){ scrollToId(id); }, 350); }
  }
  function initCartMin(){
    var flag=document.querySelector('[data-ge-cartmin="1"]'), main=document.querySelector('main[data-template]');
    if(!flag || !main || main.dataset.template!=='cart') return;
    if(typeof window.subscribe==='function' && window.PUB_SUB_EVENTS){ window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function(){ setTimeout(function(){ location.reload(); }, 300); }); }
  }
  function init(root){ initReveal(root); initPicker(root); initQuiz(root); }
  function boot(){ init(); initHeader(); initCartMin(); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
